import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'aff-home-icon',
  templateUrl: './home-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomeIconComponent {}
